import { StyleSheet } from 'react-native'
import type { Theme } from '../../../theme/getTheme'

export function getOperatorWebPaletteModalChromeStyles(theme: Theme) {
  return StyleSheet.create({
    backdrop: {
      flex: 1,
      backgroundColor: 'rgba(0,0,0,0.55)',
      justifyContent: 'center',
      alignItems: 'center',
      padding: theme.spacing.lg,
    },
    card: {
      width: '100%',
      maxWidth: 520,
      maxHeight: '88%',
      borderRadius: theme.borderRadius.lg,
      overflow: 'hidden',
      backgroundColor: theme.background.card,
    },
  })
}

export function getOperatorWebPaletteStyles(theme: Theme) {
  return StyleSheet.create({
    root: {
      flex: 1,
      maxHeight: 520,
      backgroundColor: theme.background.card,
    },
    header: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing.md,
      paddingHorizontal: theme.spacing.lg,
      paddingTop: theme.spacing.md,
      paddingBottom: theme.spacing.md,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.gray[200],
      backgroundColor: theme.background.card,
    },
    closeBtn: {
      padding: theme.spacing.sm,
      marginRight: -theme.spacing.sm,
    },
    headerTitle: {
      ...theme.typography.h3,
      color: theme.black,
      flex: 1,
    },
    scroll: {
      flexGrow: 0,
      flexShrink: 1,
    },
    scrollContent: {
      flexGrow: 1,
      width: '100%',
      maxWidth: 560,
      alignSelf: 'center',
      paddingHorizontal: theme.spacing.lg,
      paddingTop: theme.spacing.xxl,
      paddingBottom: theme.spacing.huge,
    },
    lead: {
      ...theme.typography.body,
      color: theme.gray[500],
      marginBottom: theme.spacing.xl,
    },
    input: {
      ...theme.input,
      backgroundColor: theme.background.inset,
      color: theme.black,
      width: '100%',
    },
    hint: {
      marginTop: theme.spacing.md,
      ...theme.typography.caption,
      color: theme.gray[500],
    },
    fieldError: {
      marginTop: theme.spacing.sm,
      ...theme.typography.caption,
      color: theme.error,
    },
    actions: {
      marginTop: theme.spacing.xxl,
      gap: theme.spacing.md,
    },
    btnPrimary: {
      paddingVertical: theme.spacing.md,
      paddingHorizontal: theme.spacing.lg,
      borderRadius: theme.borderRadius.md,
      backgroundColor: theme.primary,
      alignItems: 'center',
    },
    btnPrimaryText: {
      ...theme.typography.label,
      color: theme.white,
    },
    btnSecondary: {
      paddingVertical: theme.spacing.md,
      paddingHorizontal: theme.spacing.lg,
      borderRadius: theme.borderRadius.md,
      alignItems: 'center',
      borderWidth: StyleSheet.hairlineWidth,
      borderColor: theme.gray[200],
    },
    btnSecondaryText: {
      ...theme.typography.label,
      color: theme.gray[500],
    },
  })
}
